<template>
  <div class="layout-user-setting-info">
    <AppScrollbar style="height: 100%">
      <div class="setting-info">
        <el-card shadow="never">
          <div slot="header">
            <span class="theme-text">表格全局配置</span>
          </div>
          <div class="grid-config-list">
            <div class="config-item">
              <span>自动铺满</span>
              <el-switch v-model="gridConfig.fit"></el-switch>
            </div>
            <div class="config-item">
              <span>显示边框</span>
              <el-switch v-model="gridConfig.border"></el-switch>
            </div>
            <div class="config-item">
              <span>表格尺寸</span>
              <el-radio-group v-model="gridConfig.size"
                              size="mini">
                <el-radio-button label="mini">小</el-radio-button>
                <el-radio-button label="medium">中</el-radio-button>
                <el-radio-button label="large">大</el-radio-button>
              </el-radio-group>
            </div>
            <div class="config-item">
              <span>斑马线</span>
              <el-switch v-model="gridConfig.stripe"></el-switch>
            </div>
          </div>
        </el-card>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import AppScrollbar from '../elements/AppScrollbar'

export default {
  name: 'SettingInfo',
  components: {
    AppScrollbar
  },
  computed: mapState({
    gridConfig: state => state.grid.config
  })
}
</script>

<style lang="scss">
  .layout-user-setting-info {
    height: 100%;
    .setting-info {
      .el-card {
        .el-card__header {
          font-size: 12px;
          padding: 10px 15px;
        }
      }
      .el-card__body {
        font-size: 12px;
        padding: 15px;
        .grid-config-list {
          line-height: 28px;
          .config-item {
            display: flex;
            align-items: center;
            color: #606266;
            & > span {
              flex-basis: 240px;
            }
            .el-switch {
              transform: scale(.8) translateX(10%);
            }
            .el-radio-group {
              transform: scale(.9) translateX(5%);
              backface-visibility: hidden;
              .el-radio-button {
                & > .el-radio-button__inner {
                  padding: 4px 9px;
                }
              }
            }
            & + .config-item {
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
</style>
